import React from "react";

const ImageWithText = () => {
  return (
    
    
    <div className="relative w-full h-[500px]">
    {/* Navbar */}
    <nav className="bg-[#e9f4ff] flex justify-between items-center p-4">
    <div className="flex items-center">
        <img 
            src="solutions/robustLogo.png" 
            alt="Logo" 
            className="logo h-16" // Keep h-16 for height control
        />
    </div>
    <div className="flex space-x-4">
        {/* Additional navigation items can go here */}
    </div>
</nav>

  
    {/* Background Image */}
    <div class="image-container">
    <img src="logos/navbarPic.jpg" alt="Example" class="w-full h-full object-cover" />
    <div class="overlay"></div>
    <h1>Your Text Here</h1>
</div>

  
    {/* Text Overlay */}
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-10xl font-serif font-extrabold tracking-wide text-white">
      <h1 className="text-[85px] font-bold">Robust HRM Services Pvt Ltd</h1>
    </div>
  
    {/* Existing Navigation Links (optional) */}
    <nav className="absolute top-0 right-0 p-4">
      <div className="flex space-x-4">
        <a
          className="text-white hover:text-gray-600 font-medium bg-absolute px-3 py-1 rounded"
          href="#AboutUs"
        >
          About Us
        </a>
        <a
          className="text-white hover:text-gray-600 font-medium bg-absolute px-3 py-1 rounded"
          href="#ContactUs"
        >
          Contact Us
        </a>
      </div>
    </nav>
  </div>
  
  );
};

export default ImageWithText;
